import React, { useState } from 'react';
import './style.scss';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
// import { Carousel } from 'react-responsive-carousel';
import { AimListIcon } from '../../components/Icons/AimListIcon';
import { FooterLogoIcon } from '../../components/Icons/FooterLogoIcon';
import instagramIcon from '../../components/Icons/instagramIcon.svg';
import linkdinicon from '../../components/Icons/linkdinicon.svg';
import facebook from '../../components/Icons/facebook.svg';
import footerIcon from '../../components/Icons/footerIcon.png';
// import WorkCard from '../../components/Workcard';
import { MailIcon } from '../../components/Icons/MailIcon';
import Navbar from '../../components/Navbar.js';
import { LANG, BUTTON_LABELS } from '../../constants/lang';
import { Button } from '../../components/common/Button';
import { useNavigate } from 'react-router';
import { PATHS } from '../../constants/urlPaths';
import userimg from '../../assets/images/aboutImg.png';
import { ReadMore } from './ReadMore';

const { PATH_SIGNUP = '' } = PATHS;

export default function LandingPage() {
  const navigate = useNavigate();

  useState(() => {
    window.scrollTo(0, 0);
  }, []);

  const {
    PAGES: {
      HOMEPAGE: {
        // LANG_HOMEPAGE_NEXT_GEN,
        // LANG_HOMEPAGE_HEADING,
        // LANG_HOMEPAGE_OUR_PERPOSE,
        // LANG_HOMEPAGE_WE_ARE,
        LANG_HOMEPAGE_OUR_VIEW,
        // LANG_HOMEPAGE_OUR_VIEW_LONG1,
        // LANG_HOMEPAGE_OUR_VIEW_LONG2,
        // LANG_HOMEPAGE_JOIN_US,
        LANG_HOMEPAGE_HOW_WORK,
        // LANG_HOMEPAGE_WONDERING,
        // LANG_HOMEPAGE_EXPANSION_LEFT,
        // LANG_HOMEPAGE_EXPANSION_RIGHT,
        // LANG_HOMEPAGE_EXPANSION_PARA,
        // LANG_HOMEPAGE_DEPTH_LEFT,
        // LANG_HOMEPAGE_DEPTH_RIGHT,
        // LANG_HOMEPAGE_DEPTH_PARA,
        // LANG_HOMEPAGE_POTENTIAL_LEFT,
        // LANG_HOMEPAGE_POTENTIAL_RIGHT,
        // LANG_HOMEPAGE_POTENTIAL_PARA,
        LANG_HOMEPAGE_WE_AIM,
        LANG_HOMEPAGE_WE_HIGHLIGHT,
        LANG_HOMEPAGE_WE_STREAMLINE,
        LANG_HOMEPAGE_WE_FOSTER,
        LANG_HOMEPAGE_WE_REALIGN,
        LANG_HOMEPAGE_WE_UNLEASH,
        LANG_HOMEPAGE_AUTHENTIC,
        LANG_HOMEPAGE_QUICK_LINKS,
        LANG_HOMEPAGE_HOME,
        LANG_HOMEPAGE_CONTACT,
        LANG_HOMEPAGE_TERMS,
        LANG_HOMEPAGE_PRIVACY,
        LANG_HOMEPAGE_CONNECT,
        LANG_HOMEPAGE_RIGHTS,
      },
    },
    LANG_FEATURE,
    LANG_ABOUT_US,
  } = LANG;
  const { BTNLBL_SIGNUP, BTNLBL_JOIN_PUR } = BUTTON_LABELS;

  return (
    <div className=" landing-page">
      <div className="mx-auto relative">
        <navbar>
          <Navbar />
        </navbar>
        <section id="home" className="hero-section">
          <div className="content-box">
            <div className="font-sans text-[24px] leading-[32px]  sm:text-[22px] font-semibold sm:leading-[30px] text-highlight">
              <div>
                PurDriven is an innovative platform that empowers individuals to live purposeful
                lives.
              </div>
              <div className="mt-4">
                We help people find meaningful connections, pursue their dreams, achieve goals, and
                reach their fullest potential.
              </div>
            </div>
            <div className="sub-content">
              <div>
                <div className="vertical-divider" />
              </div>
              <div className="flex flex-col w-full">
                <div className="sub-title w-full">
                  While we focus on career development, it&apos;s essential to recognize the value
                  of meaningful relationships in all areas of life. A purposeful life can extend
                  beyond conventional career paths and may take the form of a lifestyle choice, an
                  entrepreneurial venture, or a personal project. We have evolved from traditional
                  professional networks to support individuals on a deeper level, particularly those
                  seeking a more fulfilling life.
                </div>
                <div className="lg:mt-7 mt-4">
                  <Button
                    label={BTNLBL_SIGNUP}
                    isIcon={true}
                    onClick={() => navigate(PATH_SIGNUP)}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="join-section" id="ourview">
          <div className="join-para">
            <div className="special-bold text-highlight text-center text-[18px] mb-4 leading-normal">
              At the heart of our mission is a commitment to helping individuals lead fulfilling
              lives. A significant source of fulfillment comes from doing what we love and
              positively impacting the lives of others.
            </div>
            <div className="special-bold text-highlight text-center">
              We encourage you to stay true to yourself to find the right opportunities that match
              who you are.
            </div>
            <div className="text-center">
              Being authentic is key to living a purposeful life. We understand who we want around
              us and the kind of places we want to be a part of or work in.
            </div>
            <div className="special-bold text-highlight text-center">
              We help you discover meaningful connections that empower you to reach your full
              potential.
            </div>
            <div className="text-center">
              Every creation and achievement comes from the dynamic collaboration of individuals.
              Our relationships form the fabric of humanity and profoundly impact us in many ways.
              Building strong connections enriches our lives and leads to extraordinary results,
              impacting our well-being, growth, and happiness.
            </div>
          </div>
          <div className="mt-8 flex justify-center">
            <Button label={BTNLBL_JOIN_PUR} isIcon={true} onClick={() => navigate(PATH_SIGNUP)} />
          </div>
          <div className="ourview-box">
            <div className="heading">{LANG_HOMEPAGE_OUR_VIEW}</div>
            <div className="underline" />
            <div className="flex flex-col gap-2">
              <div className="content special_text mt-5 !text-highlight">
                Deep and meaningful relationships have always been, and will continue to be,
                essential for humans.
              </div>
              <div className="content">
                We are entering an unprecedented era in which advanced technology is set to replace
                many human jobs. At the same time, there is a growing demand for meaningful
                relationships, which are crucial for mental health and well-being and the core of
                organizational human resources.
              </div>
              <div className="content">
                Virtual interactions, along with robots and AI, are (should be) designed to assist
                and enhance our lives. Change will occur rapidly, and at some point, we may face a
                collective human existential crisis as AI takes over many tasks, prompting us to
                reflect on the very meaning of our existence.
              </div>
              <div className="content">
                Despite technological advancements, our innate desire for purpose, connection, and
                collaboration remains unchanged. It goes beyond simply achieving results; it
                encompasses contributing to society, finding fulfillment, and expressing our most
                authentic selves.
              </div>
            </div>
          </div>
        </section>
        <section id="about-work" className="work-section pb-8">
          <div className="heading text-center !max-w-full">{LANG_HOMEPAGE_HOW_WORK}</div>
          {/* <div className="underline mx-auto" /> */}
          <div className="content mt-6 mx-auto text-center">
            Our platform enables users to create a broader and more authentic profile than what is
            typically found on current social media sites. Users can share their attributes,
            personalities, behaviors, interests, and values, moving beyond traditional resumes
            focusing mainly on skills, experience, and education.
          </div>
          <div className="content mt-12 mx-auto text-center">
            We streamline the process of discovering the unique person you are looking for.
            PurDriven optimizes the user&apos;s search results and overall experience by offering a
            more comprehensive, profound, and relevant view of individuals.
          </div>
          <div className="content mt-[48px] md:mt-10 pb-11 mx-auto text-center !text-[19px] !leading-normal">
            We encourage users to enhance their awareness of their own unique traits and those of
            others. The more we understand ourselves and each other, the better decisions we can
            make to create a high-performing, positive team (two or more people).
          </div>

          {/* <Carousel
            showArrows={false}
            autoFocus={true}
            showThumbs={false}
            showStatus={false}
            className="presentation-mode"
          >
            <WorkCard
              titleLeft={LANG_HOMEPAGE_EXPANSION_LEFT}
              titleRight={LANG_HOMEPAGE_EXPANSION_RIGHT}
              content={LANG_HOMEPAGE_EXPANSION_PARA}
            />
            <WorkCard
              titleLeft={LANG_HOMEPAGE_DEPTH_LEFT}
              titleRight={LANG_HOMEPAGE_DEPTH_RIGHT}
              content={LANG_HOMEPAGE_DEPTH_PARA}
            />
            <WorkCard
              titleLeft={LANG_HOMEPAGE_POTENTIAL_LEFT}
              titleRight={LANG_HOMEPAGE_POTENTIAL_RIGHT}
              content={LANG_HOMEPAGE_POTENTIAL_PARA}
            />
          </Carousel> */}
        </section>
        {/* About Section */}
        <section className="about-section ">
          <div className="text-[20px] font-medium mb-10 text-highlight">
            We invite you to uncover the most exciting opportunities and connect with others who
            truly resonate with your authentic self. Join us in enriching your relationships and
            unlocking their potential!
          </div>
          <div className="flex gap-[32px]">
            <div className="hidden md:block">
              <img src={userimg} alt="" />
            </div>
            <div className="flex flex-col justify-content-between md:max-w-[calc(100%-200px)]">
              <div className="heading">
                About the founder
                <div className="underline" />
              </div>
              <div className="md:hidden pt-4 block">
                <img src={userimg} alt="" />
              </div>
              <div className="name p-0 lg:pt-4">- Ludgi Windrich</div>
              <div className="yellow-text ml-4">The vision and the why</div>
            </div>
          </div>
          <div className="mt-4">
            <ReadMore
              text={
                <>
                  The vision for PurDriven is to create a space where people feel comfortable being
                  their authentic selves. Here, everyone is accepted, respected, embraced, inspired,
                  and empowered to express their uniqueness while supporting each other&apos;s
                  passions.
                  <br />
                  <br />
                  How did I get here?
                  <br />
                  At a pivotal moment in my life, I decided to change my direction and prioritize
                  the pursuit of meaning and purpose. I was considering a career change. Upon
                  reviewing my resume, I realized how ineffective it was in supporting my transition
                  to a new and fulfilling career. Our resumes often tell only a fraction of who we
                  are. It felt superficial and was primarily focused on my past experiences, leaving
                  me far from achieving my goals.
                </>
              }
              moreText={
                <>
                  The vision for PurDriven is to create a space where people feel comfortable being
                  their authentic selves. Here, everyone is accepted, respected, embraced, inspired,
                  and empowered to express their uniqueness while supporting each other&apos;s
                  passions.
                  <br />
                  <br />
                  How did I get here?
                  <br />
                  At a pivotal moment in my life, I decided to change my direction and prioritize
                  the pursuit of meaning and purpose. I was considering a career change. Upon
                  reviewing my resume, I realized how ineffective it was in supporting my transition
                  to a new and fulfilling career. Our resumes often tell only a fraction of who we
                  are. It felt superficial and was primarily focused on my past experiences, leaving
                  me far from achieving my goals.
                  <br />
                  <br />
                  This realization inspired the creation of PurDriven, a heartfelt commitment to
                  nurture our intrinsic desire for a meaningful life.
                  <br />
                  {/* PurDriven highlights the importance of meaningful relationships in all aspects of
                  life, as a purposeful life may go beyond traditional career paths. It can manifest
                  in a way of life, an entrepreneurial venture, or a personal project. */}
                  <br />
                  We encourage users to authentically express themselves by customizing their
                  profiles to reflect what truly matters to them. While some individuals may have
                  specialized technical interests, others might identify as multipotentialites or
                  engage in arts, sports, or spiritual practices. Regardless of one&apos;s focus,
                  our objective is to cultivate meaningful connections that support people&apos;s
                  passions.
                  <br />
                  <br />
                  We see the full circle - we believe that authenticity leads to finding the right
                  match, which helps us bring out our best selves, allowing us to embrace who we
                  truly are.
                  <br />
                  <br />
                  For some, PurDriven will be a journey of self-awareness and action toward
                  realizing their dreams. People will evolve along the way, and we hope to see a
                  shift toward more engaged, effective, and fulfilled individuals.
                  <br />
                  <br />I couldn&apos;t be more excited and grateful to be part of this amazing
                  platform. Let us all strive to live authentically and appreciate the gift of doing
                  something we love.
                </>
              }
            />
          </div>
        </section>
        <section className="weaim-section hidden">
          <div className="heading">{LANG_HOMEPAGE_WE_AIM}</div>
          <div className="underline" />
          <div className="content mt-2">{LANG_HOMEPAGE_WE_HIGHLIGHT}</div>
          <ul>
            <li className="flex flex-row items-start">
              <AimListIcon />
              {LANG_HOMEPAGE_WE_STREAMLINE}
            </li>
            <li className="flex flex-row items-start">
              <AimListIcon />
              {LANG_HOMEPAGE_WE_FOSTER}
            </li>
            <li className="flex flex-row items-start">
              <AimListIcon />
              {LANG_HOMEPAGE_WE_REALIGN}
            </li>
            <li className="flex flex-row items-start">
              <AimListIcon />
              {LANG_HOMEPAGE_WE_UNLEASH}
            </li>
            <li className="flex flex-row items-start">
              <AimListIcon />
              {LANG_HOMEPAGE_AUTHENTIC}
            </li>
          </ul>
        </section>
        {/* Footer Section */}
        <footer className="footer-section" id="contact-us">
          <div className="footer-logo mb-6">
            <FooterLogoIcon />
          </div>
          <div className="landing-footer">
            <div>
              <div className="purpose-text mb-10">{LANG_HOMEPAGE_AUTHENTIC}</div>
              <div className="flex items-center gap-6 email pt-4 md:pb-4 pb-0">
                <span>
                  <MailIcon />
                </span>
                <span className>info@purdriven.com</span>
              </div>
            </div>
            <div>
              <div className="footer-link-heading">{LANG_HOMEPAGE_QUICK_LINKS}</div>
              <div className="flex gap-8">
                <div className="footer-links mb-8">
                  <ul>
                    <li>
                      <a>{LANG_HOMEPAGE_HOME}</a>
                    </li>
                    <li>
                      <a>{LANG_ABOUT_US}</a>
                    </li>
                    <li>
                      <a>{LANG_FEATURE}</a>
                    </li>
                    <li>
                      <a>{LANG_HOMEPAGE_CONTACT}</a>
                    </li>
                  </ul>
                </div>
                <div className="footer-links">
                  <ul>
                    <li>
                      <a
                        href="https://app.termly.io/policy-viewer/policy.html?policyUUID=15f1aff0-1772-41fb-8b81-1fe1a05143b3"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {LANG_HOMEPAGE_TERMS}
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://app.termly.io/policy-viewer/policy.html?policyUUID=a09c8bcd-7676-46b1-b045-ba6f2b3fc5f7"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {LANG_HOMEPAGE_PRIVACY}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div style={{ zIndex: 60 }}>
              <div>
                <div className="footer-link-heading">{LANG_HOMEPAGE_CONNECT}</div>
                <div className="flex gap-6 icon-gap items-center mt-5 pb-8">
                  <div className="social-links">
                    <a
                      href="https://www.linkedin.com/company/purdriven/"
                      rel="noreferrer"
                      target="_blank"
                    >
                      <img src={linkdinicon} alt="" />
                    </a>
                  </div>
                  <div className="social-links">
                    <a href="https://www.instagram.com/purdriven/" rel="noreferrer" target="_blank">
                      <img src={instagramIcon} alt="" />
                    </a>
                  </div>
                  <div className="social-links">
                    <a
                      href="https://www.facebook.com/meintelifestyle"
                      rel="noreferrer"
                      target="_blank"
                    >
                      <img src={facebook} alt="" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="absolute bottom-0 right-0 ">
            <img src={footerIcon} alt="" className="landing-footer-img" />
          </div>
          <div className="py-5 text-center copyright">&#169; {LANG_HOMEPAGE_RIGHTS}</div>
        </footer>
      </div>
    </div>
  );
}
